export default __webpack_public_path__ + "static/media/Brigand's Leggings of the Bloody Fang.c97b8180.jpg";